import { Grid, Typography } from '@material-ui/core';
import moment from 'moment';
import React from 'react';
import { convertCurrency } from 'src/common/helpers/currency-helper';
import { ITransactionListing } from 'src/common/helpers/transaction-helper';
import { savedTransactionStyles } from './saved-transaction-list-styles';

export const SavedTransactionListings = (props: SavedTransactionListingProps): JSX.Element => {
  const classes = savedTransactionStyles();
  const { listing, selected, testIdPrefix } = props;
  const className = `result ${selected ? `${classes.selected}` : ''}`;
  const grandAmount = listing.totalOrderAmount || 0;
  const touchPointId = listing.touchPointId;
  const closeDateTimeUtc = listing.suspendTime;
  const transactionNumber = listing.sequenceNumber;

  return (
    <Grid
      direction='column'
      spacing={0}
      wrap='nowrap'
      container
      onClick={() => props.onSelect(listing)}
      className={`${classes.savedTransactionListContainer} ${className}`}
      data-testid={`${testIdPrefix}${selected ? '-selected' : ''}`}
    >
      <Grid item className='fullHeight'>
        <Grid container justifyContent='flex-start' className={classes.row}>
          <Grid item xs={3} className={classes.outerDetailContainer}>
            <Grid container item xs={9}>
              <Grid
                item
                container
                className={`${classes.innerDetailInformationContainer} ${classes.showOverflow}`}
              >
                <Typography variant='body2' data-testid='date-time'>
                  {moment.utc(closeDateTimeUtc).format('L')}{' '}
                  {moment
                    .utc(closeDateTimeUtc)
                    .local()
                    .format('LT')}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={1} className={classes.outerDetailContainer}>
            <Grid container item xs={9}>
              <Grid item container className={classes.innerDetailInformationContainer}>
                <Typography variant='body2' data-testid='touchpoint'>
                  {touchPointId}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={3} className={classes.outerDetailContainer}>
            <Grid container item xs={9}>
              <Grid
                item
                container
                className={`${classes.innerDetailInformationContainer} ${classes.containerAlignment}`}
              >
                <Typography variant='body2' data-testid='transaction-number'>
                  {transactionNumber}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={2} className={classes.outerDetailContainer}>
            <Grid container item xs={9}>
              <Grid item container className={classes.innerDetailInformationContainer}>
                <Typography variant='body2' data-testid='grand-amount'>
                  {convertCurrency(grandAmount)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

interface SavedTransactionListingProps {
  listing: ITransactionListing;
  selected: boolean;
  onSelect: (selectedTransaction: ITransactionListing) => void;
  testIdPrefix: string;
}
